<div
  fxLayout="column"
  fxLayoutAlign="space-between"
>
  <div
    fxLayout="row"
    fxLayoutAlign="space-between"
  >
    <h3><i class="mdi mdi-phone-missed s18 mr-5 orange-fg"></i> {{ alert.title }}</h3>
  </div>
  <div>
    <!-- class="ph-24 pt-10">-->
    <div>{{ alert.description }}</div>
    <div>{{ alert.created | date : 'short' }}</div>
    <hr />
  </div>
</div>
